/* =====================================================================
   Maison Stiletto (base V5) : fiche produit (mp-product, mp-complete-look, mp-product-recos)
   Charge en defer par mp-global apres mp-base.js (window.MP) sur product et password.
   - Selection des variantes par index d'option (JSON [data-mp-product-json], prix en centimes),
     disponibilites, prix, libelles, ?variant= dans l'URL.
   - Noms de couleur affiches en casse titre : le Liquid pose le nom a afficher dans data-display de chaque
     radio (une seule regle de casse, cote serveur) ; les valeurs envoyees restent celles de Shopify.
   - Ajout au panier : MP.add([{id, quantity}]) -> MPCart.add (tiroir). Jamais de bouton desactive :
     sans taille, message "Select a size." + secousse de la grille.
   - Galerie : groupes de photos par couleur (data-mp-color pose en Liquid), carrousel mobile
     (compteur, points), visionneuse plein ecran MP.layer avec zoom (double clic / double tap,
     molette, pincement) et deplacement.
   - Barre d'achat collante (IntersectionObserver), colonne d'achat collante meme si elle est haute.
   - Recommandations Shopify (related / complementary) chargees a l'approche, filtrees par genre.
   ===================================================================== */
(function () {
  'use strict';

  var doc = document;
  var NBSP = '\u00a0';

  function $(sel, root) { return (root || doc).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || doc).querySelectorAll(sel)); }
  function MPx() { return window.MP || {}; }
  // repli si MP.money est absent : meme rendu que mp-money ("$88", "$88.50", "$1,250")
  function money(c) {
    var M = MPx();
    if (M.money) return M.money(c);
    var cents = Math.round(c);
    var neg = cents < 0;
    cents = Math.abs(cents);
    var whole = String(Math.floor(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var rest = cents % 100;
    return (neg ? '−' : '') + '$' + whole + (rest ? '.' + (rest < 10 ? '0' : '') + rest : '');
  }
  function reduceMotion() {
    var M = MPx();
    return !!(M.mq && M.mq.reduce && M.mq.reduce.matches);
  }
  function isDesktop() {
    var M = MPx();
    if (M.mq && M.mq.desktop) return M.mq.desktop.matches;
    return window.innerWidth >= 990;
  }
  function announce(t) { var M = MPx(); if (M.announce) M.announce(t); }

  /* ---------- Textes : bloc <script data-mp-i18n="product"> rendu par la section, repli anglais ----------
     [jeton] dans une chaine = valeur passee a tr(cle, { jeton: valeur }). */
  var FALLBACK = {
    price: 'Price',
    sale_price: 'Sale price',
    pct_off: '−[pct]%',
    colon: ':',
    color: 'Color',
    add_to_bag: 'Add to bag',
    sold_out: 'Sold out',
    adding: 'Adding…',
    added: 'Added',
    added_announce: 'Added to bag.',
    bar_add: 'Add',
    size_sold_out: 'This size is sold out.',
    select_size: 'Select a size.',
    select_option: 'Select an option.',
    size_meta: 'size [size]',
    zoom_photo: 'Enlarge photo [index] of [total]',
    slide: 'slide',
    slide_of: '[index] of [total]',
    viewer_hint_desktop: 'Double-click or use the mouse wheel to zoom.',
    viewer_hint_touch: 'Double-tap or pinch to zoom.',
    error: 'Something went wrong. Please try again in a moment.'
  };
  var DICT = null;
  function loadDict() {
    if (DICT) return DICT;
    var el = doc.querySelector('script[data-mp-i18n="product"]');
    if (!el) return null;
    try { DICT = JSON.parse(el.textContent || '{}') || {}; } catch (e) { DICT = {}; }
    return DICT;
  }
  function tr(key, vars) {
    // MP.t (mp-base.js) lit le meme bloc et relit apres un rechargement de section ; repli local sinon
    var M = MPx();
    if (typeof M.t === 'function') return M.t('product', key, FALLBACK[key], vars);
    var d = loadDict();
    var s = d && typeof d[key] === 'string' && d[key] !== '' ? d[key] : FALLBACK[key];
    if (s == null) return '';
    if (vars) {
      Object.keys(vars).forEach(function (k) { s = s.split('[' + k + ']').join(String(vars[k])); });
    }
    return s;
  }

  function errorText(e) { var M = MPx(); return M.errorText ? M.errorText(e) : tr('error'); }
  function shake(el) {
    if (!el) return;
    el.classList.remove('mp-shake');
    void el.offsetWidth; // relance l'animation
    el.classList.add('mp-shake');
    setTimeout(function () { el.classList.remove('mp-shake'); }, 450);
  }
  function headerOffset() {
    var v = window.getComputedStyle(doc.documentElement).getPropertyValue('--mp-header-offset');
    var n = parseFloat(v);
    return isNaN(n) ? 0 : n;
  }
  // deplace un calque dans body (abri d'un ancetre a transform ou content-visibility) ; owner = id de section
  function portal(el, owner) {
    if (!el) return el;
    el.setAttribute('data-mp-owner', owner);
    var M = MPx();
    if (M.portal) M.portal(el);
    else if (el.parentNode !== doc.body) doc.body.appendChild(el);
    return el;
  }
  function dropPortals(owner, keep) {
    $$('body > [data-mp-owner="' + owner + '"]').forEach(function (n) {
      if (keep.indexOf(n) === -1 && n.parentNode) n.parentNode.removeChild(n);
    });
  }

  /* =====================================================================
     1. Fiche produit
     ===================================================================== */
  function initProduct(root) {
    if (!root || root.__mpProduct) return;
    var jsonEl = $('[data-mp-product-json]', root);
    if (!jsonEl) return;
    var data;
    try { data = JSON.parse(jsonEl.textContent || '{}'); } catch (e) { return; }
    root.__mpProduct = true;

    var sid = root.getAttribute('data-section-id') || '';
    var variants = data.variants || [];
    var nOpt = (data.options || []).length;
    var ci = typeof data.colorIndex === 'number' ? data.colorIndex : -1;
    var si = typeof data.sizeIndex === 'number' ? data.sizeIndex : -1;

    var info = $('.mp-product__info', root);
    var form = $('[data-mp-product-form]', root);
    var idInput = $('[data-mp-product-id]', root);
    var addBtn = $('[data-mp-product-add]', root);
    var addLabel = $('[data-mp-add-label]', root);
    var addPrice = $('[data-mp-add-price]', root);
    var msg = $('[data-mp-product-msg]', root);
    var sizeSet = $('[data-mp-size]', root);
    var sizeMsg = $('[data-mp-size-msg]', root);
    var express = $('[data-mp-express]', root);
    var guard = $('[data-mp-express-guard]', root);
    var priceNow = $('[data-mp-price-now]', root);
    var priceWas = $('[data-mp-price-was]', root);
    var priceWasSr = $('[data-mp-price-was-sr]', root);
    var priceSr = $('[data-mp-price-sr]', root);
    var pricePct = $('[data-mp-price-pct]', root);
    var saleNote = $('[data-mp-sale-note]', root);
    var colorName = $('[data-mp-color-name]', root);
    var bar = $('[data-mp-bar]', root);
    var viewer = $('[data-mp-viewer]', root);
    var guide = $('.mp-product__guide', root);

    // calques et barre fixes : a l'abri dans body (et nettoyage apres rechargement dans l'editeur)
    dropPortals(sid, []);
    portal(viewer, sid);
    portal(guide, sid);
    portal(bar, sid);

    var barPrice = bar ? $('[data-mp-bar-price]', bar) : null;
    var barMeta = bar ? $('[data-mp-bar-meta]', bar) : null;
    var barBtn = bar ? $('[data-mp-bar-add]', bar) : null;
    var barLabel = bar ? $('[data-mp-bar-label]', bar) : null;
    var barLabelD = bar ? $('[data-mp-bar-label-d]', bar) : null;

    /* ---------- Etat des options ---------- */
    var inputsByOpt = [];
    var sel = [];
    for (var i = 0; i < nOpt; i++) {
      inputsByOpt[i] = $$('[data-mp-opt-input="' + i + '"]', root);
      sel[i] = null;
      inputsByOpt[i].forEach(function (inp) { if (inp.checked) sel[i] = inp.value; });
    }
    // options sans selecteur (ex. option unique masquee) : valeur de la 1re variante disponible
    var first = null;
    for (var k = 0; k < variants.length; k++) { if (variants[k].a) { first = variants[k]; break; } }
    first = first || variants[0] || null;
    for (var j = 0; j < nOpt; j++) {
      if (!inputsByOpt[j].length && first) sel[j] = first.o[j];
    }

    function matches(v, s, skip) {
      for (var x = 0; x < nOpt; x++) {
        if (x === skip) continue;
        if (s[x] != null && v.o[x] !== s[x]) return false;
      }
      return true;
    }
    function current() {
      for (var x = 0; x < nOpt; x++) if (sel[x] == null) return null;
      for (var y = 0; y < variants.length; y++) if (matches(variants[y], sel, -1)) return variants[y];
      return null;
    }
    // variante de reference pour le prix quand la taille n'est pas encore choisie
    function reference() {
      var best = null;
      for (var y = 0; y < variants.length; y++) {
        var v = variants[y];
        if (!matches(v, sel, -1)) continue;
        if (v.a) return v;
        if (!best) best = v;
      }
      return best || first;
    }
    function optionAvailable(index, value) {
      for (var y = 0; y < variants.length; y++) {
        var v = variants[y];
        if (!v.a || v.o[index] !== value) continue;
        // une couleur est disponible si au moins une taille l'est ; les autres options suivent la selection
        if (index === ci) return true;
        if (matches(v, sel, index)) return true;
      }
      return false;
    }
    function missingIndex() {
      for (var x = 0; x < nOpt; x++) if (sel[x] == null) return x;
      return -1;
    }
    // nom a afficher d'une valeur : data-display du radio (couleur en casse titre), sinon la valeur telle quelle
    function shown(index, value) {
      var list = inputsByOpt[index] || [];
      for (var q = 0; q < list.length; q++) {
        if (list[q].value === value) return list[q].getAttribute('data-display') || value;
      }
      return value;
    }

    /* ---------- Rendu ---------- */
    function setMsg(el, text) { if (el) el.textContent = text || ''; }

    function setAddLabel(text, withPrice) {
      if (addLabel) addLabel.textContent = text;
      if (addPrice) addPrice.hidden = !withPrice;
    }

    function update(fromUser, changed) {
      // disponibilites
      for (var x = 0; x < nOpt; x++) {
        inputsByOpt[x].forEach(function (inp) {
          var ok = optionAvailable(x, inp.value);
          var label = inp.closest('label');
          if (!label) return;
          var dot = $('.mp-dot', label);
          if (x === ci && root.classList.contains('mp-product--contain')) {
            label.classList.remove('is-out');
            if (dot) dot.classList.remove('is-out');
          } else if (dot) dot.classList.toggle('is-out', !ok);
          else label.classList.toggle('is-out', !ok);
          var t = $('[data-mp-out-text]', label);
          if (t) t.hidden = ok;
        });
        var s = $('[data-mp-opt-sel="' + x + '"]', root);
        // "Size: M" ; chaussures : "Size: EU 38" (prefixe pose en Liquid dans data-prefix) ; en francais "Taille : M"
        if (s) s.textContent = sel[x] != null ? tr('colon') + ' ' + (s.getAttribute('data-prefix') || '') + shown(x, sel[x]) : '';
      }
      if (colorName && ci > -1 && sel[ci] != null) colorName.textContent = shown(ci, sel[ci]);

      var v = current();
      var ref = v || reference();

      // prix
      if (ref) {
        var sale = ref.c > ref.p;
        if (priceNow) {
          priceNow.textContent = money(ref.p);
          priceNow.classList.toggle('mp-price__now--sale', sale);
        }
        if (priceWas) { priceWas.hidden = !sale; priceWas.textContent = sale ? money(ref.c) : ''; }
        if (priceWasSr) priceWasSr.hidden = !sale;
        if (priceSr) priceSr.textContent = sale ? tr('sale_price') : tr('price');
        if (pricePct) {
          pricePct.hidden = !sale;
          pricePct.textContent = sale ? tr('pct_off', { pct: Math.round((ref.c - ref.p) * 100 / ref.c) }) : '';
        }
        if (saleNote) saleNote.hidden = !sale;
        // bouton "Add to bag | $128 $89.60" : ancien prix barre seulement en promo (repli : ancien rendu " · $88")
        if (addPrice) {
          var addNow = $('[data-mp-add-now]', addPrice);
          var addWas = $('[data-mp-add-was]', addPrice);
          if (addNow) addNow.textContent = money(ref.p);
          else addPrice.textContent = NBSP + '· ' + money(ref.p);
          if (addWas) { addWas.hidden = !sale; addWas.textContent = sale ? money(ref.c) : ''; }
        }
        if (barPrice) barPrice.textContent = money(ref.p);
      }

      // bouton principal : jamais desactive, "Sold out" seulement si la combinaison choisie l'est
      var soldOut = (v && !v.a) || (!v && ref && !ref.a && missingIndex() === -1);
      if (soldOut) {
        setAddLabel(tr('sold_out'), false);
        addBtn && addBtn.setAttribute('aria-disabled', 'true');
      } else {
        setAddLabel(tr('add_to_bag'), true);
        addBtn && addBtn.removeAttribute('aria-disabled');
      }
      if (barLabel && !barBusy) {
        barLabel.textContent = soldOut ? tr('sold_out') : tr('bar_add');
        if (barLabelD) barLabelD.hidden = soldOut;
      }

      // id envoye (formulaire sans JS, paiement express)
      if (idInput) {
        if (v) idInput.value = v.id;
        else if (ref) idInput.value = ref.id;
      }
      // paiement express verrouille tant que la taille n'est pas choisie (ou qu'elle est epuisee)
      if (guard) guard.hidden = !!(v && v.a);

      // messages
      if (fromUser) {
        setMsg(msg, '');
        if (v && !v.a) setMsg(sizeMsg, tr('size_sold_out'));
        else setMsg(sizeMsg, '');
        if (sizeSet && sel[si] != null) sizeSet.classList.remove('is-invalid');
      }

      // barre collante : couleur et taille
      if (barMeta) {
        var parts = [];
        if (ci > -1 && sel[ci] != null) parts.push(shown(ci, sel[ci]));
        // taille unique ("One size fits all") : pas un choix, donc pas dans la barre
        if (si > -1 && sel[si] != null && inputsByOpt[si].length > 1) parts.push(tr('size_meta', { size: sel[si] }));
        barMeta.textContent = parts.join(', ');
      }

      // galerie de la couleur choisie
      if (changed === ci && ci > -1) gallery.color(sel[ci]);

      // URL partageable
      if (fromUser && v && window.history && window.history.replaceState) {
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          window.history.replaceState(window.history.state, '', u.toString());
        } catch (e) { /* URL non supportee : sans gravite */ }
      }
    }

    root.addEventListener('change', function (e) {
      var inp = e.target && e.target.closest ? e.target.closest('[data-mp-opt-input]') : null;
      if (!inp) return;
      var idx = parseInt(inp.getAttribute('data-mp-opt-input'), 10);
      sel[idx] = inp.value;
      update(true, idx);
      if (idx === ci) announce(tr('color') + tr('colon') + ' ' + shown(ci, inp.value));
    });

    /* ---------- Ajout au panier ("Add to bag" -> "Adding..." -> "Added") ---------- */
    var busy = false;
    var barBusy = false;

    function showMissing() {
      var idx = missingIndex();
      if (idx === -1) return;
      var set = idx === si ? sizeSet : $('[data-mp-opt="' + idx + '"]', root);
      var text = idx === si ? tr('select_size') : tr('select_option');
      setMsg(sizeMsg, text);
      if (!sizeMsg) setMsg(msg, text);
      if (set) {
        set.classList.add('is-invalid');
        shake($('[data-mp-chips]', set) || set);
        setTimeout(function () { set.classList.remove('is-invalid'); }, 2000);
        var r = set.getBoundingClientRect();
        var top = headerOffset() + 16;
        if (r.top < top || r.bottom > window.innerHeight - 80) {
          window.scrollTo({ top: window.pageYOffset + r.top - top - 24, behavior: reduceMotion() ? 'auto' : 'smooth' });
        }
        var firstOk = null;
        (inputsByOpt[idx] || []).some(function (inp) {
          var l = inp.closest('label');
          if (l && !l.classList.contains('is-out')) { firstOk = inp; return true; }
          return false;
        });
        firstOk = firstOk || (inputsByOpt[idx] || [])[0];
        if (firstOk) {
          try { firstOk.focus({ preventScroll: true }); } catch (err) { firstOk.focus(); }
        }
      }
      announce(text);
    }

    function addToCart(fromBar) {
      if (busy) return;
      setMsg(msg, '');
      var v = current();
      if (!v) { showMissing(); return; }
      if (!v.a) {
        setMsg(sizeMsg || msg, tr('size_sold_out'));
        if (fromBar && sizeSet) showSizeArea();
        return;
      }
      busy = true;
      if (addBtn) addBtn.setAttribute('aria-busy', 'true');
      setAddLabel(tr('adding'), false);
      setBarLabel(tr('adding'));
      var M = MPx();
      var p = M.add ? M.add([{ id: v.id, quantity: 1 }]) : Promise.reject({ message: '' });
      p.then(function () {
        setAddLabel(tr('added'), false);
        setBarLabel(tr('added'));
        announce(tr('added_announce'));
        setTimeout(function () {
          busy = false;
          barBusy = false;
          if (addBtn) addBtn.removeAttribute('aria-busy');
          update(false, -1);
        }, 1600);
      }).catch(function (err) {
        busy = false;
        barBusy = false;
        if (addBtn) addBtn.removeAttribute('aria-busy');
        update(false, -1);
        var t = errorText(err);
        setMsg(msg, t);
        announce(t);
      });
    }
    function setBarLabel(text) {
      if (!barLabel) return;
      barBusy = true;
      barLabel.textContent = text;
      if (barLabelD) barLabelD.hidden = true;
    }
    function showSizeArea() {
      var r = sizeSet.getBoundingClientRect();
      window.scrollTo({ top: window.pageYOffset + r.top - headerOffset() - 40, behavior: reduceMotion() ? 'auto' : 'smooth' });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        addToCart(false);
      });
    }
    if (barBtn) barBtn.addEventListener('click', function () { addToCart(true); });
    if (guard) {
      guard.addEventListener('click', function (e) {
        e.preventDefault();
        var v = current();
        if (!v) showMissing();
        else if (!v.a) setMsg(sizeMsg || msg, tr('size_sold_out'));
      });
    }
    // clavier sur un bouton express pendant le verrouillage : meme effet que le voile
    if (express) {
      express.addEventListener('click', function (e) {
        if (!guard || guard.hidden) return;
        if (e.target && e.target.closest && e.target.closest('[data-mp-express-guard]')) return;
        e.preventDefault();
        e.stopPropagation();
        var v = current();
        if (!v) showMissing();
        else setMsg(sizeMsg || msg, tr('size_sold_out'));
      }, true);
    }

    /* ---------- Galerie ---------- */
    var gallery = (function () {
      var wrap = $('[data-mp-gallery]', root);
      var track = $('[data-mp-gallery-track]', root);
      var count = $('[data-mp-gallery-count]', root);
      var dots = $('[data-mp-gallery-dots]', root);
      var slides = track ? $$('[data-mp-slide]', track) : [];
      var wideOn = wrap ? wrap.getAttribute('data-wide') === 'true' : false;
      var colorInputs = ci > -1 ? inputsByOpt[ci] : [];
      var index = 0;

      function visible() { return slides.filter(function (s) { return !s.hidden; }); }
      // V1.14 : rang de la couleur dans l'option (data-mp-ci), pas la place de la pastille : avec les groupes
      // Base / Limited edition, les pastilles ne sont plus dans l'ordre de l'option (rose -> photos kaki)
      function colorIdx(value) {
        for (var x = 0; x < colorInputs.length; x++) {
          if (colorInputs[x].value === value) return colorInputs[x].getAttribute('data-mp-ci') || String(x);
        }
        return '';
      }
      // V1.16 : barre de progression (mobile) et ligne « Model is ... and wears size ... » qui suit la photo
      var bar = $('[data-mp-gallery-bar]', root);
      var modelLine = $('[data-mp-model-line]', root);
      function paintBar() {
        if (!bar || !track) return;
        var n = visible().length;
        var max = track.scrollWidth - track.clientWidth;
        var r = max > 0 ? Math.min(1, Math.max(0, track.scrollLeft / max)) : 0;
        bar.style.setProperty('--mp-bar-w', (100 / Math.max(1, n)) + '%');
        bar.style.setProperty('--mp-bar-x', (r * (n - 1) * 100) + '%');
      }
      function setModel(vis) {
        // V1.22 : sur ordinateur, une seule pastille « Model is ... », sur la 1re photo de mannequin visible
        var first = null;
        for (var y = 0; y < vis.length && !first; y++) if (vis[y].hasAttribute('data-mp-model')) first = vis[y];
        slides.forEach(function (s) { s.classList.toggle('is-pill', s === first); });
        if (!modelLine) return;
        var s = vis[index] && vis[index].getAttribute('data-mp-model');
        if (!s) {
          for (var x = 0; x < vis.length && !s; x++) s = vis[x].getAttribute('data-mp-model');
        }
        if (!s) { modelLine.hidden = true; return; }
        var p = s.split('~');
        modelLine.textContent = (modelLine.getAttribute('data-tpl') || '').replace('[h]', p[0]).replace('[s]', p[1] || '');
        modelLine.hidden = false;
      }
      function setIndex(i) {
        var vis = visible();
        index = Math.max(0, Math.min(i, vis.length - 1));
        if (count) count.textContent = (index + 1) + ' / ' + vis.length;
        if (dots) $$('span', dots).forEach(function (d, n) { d.classList.toggle('is-on', n === index); });
        setModel(vis);
      }
      function relayout() {
        var vis = visible();
        slides.forEach(function (s) { s.classList.remove('is-wide'); });
        if ((wideOn && vis.length > 2 && vis.length % 2 === 1) || vis.length === 1) vis[0].classList.add('is-wide');
        vis.forEach(function (s, n) {
          var b = $('[data-mp-zoom]', s);
          if (b) b.setAttribute('aria-label', tr('zoom_photo', { index: n + 1, total: vis.length }));
          var img = $('img', s);
          if (img && n < 2) img.loading = 'eager';
        });
        if (dots) {
          dots.innerHTML = '';
          for (var d = 0; d < vis.length; d++) dots.appendChild(doc.createElement('span'));
          dots.hidden = vis.length < 2;
        }
        if (count) count.hidden = vis.length < 2;
        if (bar) bar.hidden = vis.length < 2;
        if (track) track.scrollLeft = 0;
        setIndex(0);
        paintBar();
      }
      function color(value) {
        if (!slides.length) return;
        var idx = colorIdx(value);
        var has = idx !== '' && slides.some(function (s) { return s.getAttribute('data-mp-color') === idx; });
        slides.forEach(function (s) {
          var g = s.getAttribute('data-mp-color');
          s.hidden = has && g !== '-1' && g !== idx;
        });
        relayout();
      }

      if (track) {
        var ticking = false, barFrame = 0;
        track.addEventListener('scroll', function () {
          if (bar && !barFrame) barFrame = requestAnimationFrame(function () { barFrame = 0; paintBar(); });
          if (ticking) return;
          ticking = true;
          setTimeout(function () {
            ticking = false;
            if (track.clientWidth) setIndex(Math.round(track.scrollLeft / track.clientWidth));
          }, 60);
        }, { passive: true });

        // clic = visionneuse ; sur mobile, double tap = visionneuse deja zoomee au point touche
        var tapTimer = null;
        var tapSlide = null;
        track.addEventListener('click', function (e) {
          var b = e.target && e.target.closest ? e.target.closest('[data-mp-zoom]') : null;
          if (!b || !viewer) return;
          var slide = b.closest('[data-mp-slide]');
          var i = visible().indexOf(slide);
          if (isDesktop() || e.detail === 0) { viewerApi.open(i, b, null); return; }
          var pt = { x: e.clientX, y: e.clientY };
          if (tapTimer && tapSlide === slide) {
            clearTimeout(tapTimer);
            tapTimer = null;
            viewerApi.open(i, b, pt);
            return;
          }
          tapSlide = slide;
          tapTimer = setTimeout(function () { tapTimer = null; viewerApi.open(i, b, null); }, 280);
        });
      }

      return {
        color: color,
        visible: visible,
        index: function () { return index; },
        goTo: function (i) {
          if (!track || isDesktop()) return;
          track.scrollLeft = i * track.clientWidth;
          setIndex(i);
        }
      };
    })();

    /* ---------- Visionneuse (zoom) ---------- */
    var viewerApi = (function () {
      if (!viewer) return { open: function () {} };
      var vTrack = $('[data-mp-viewer-track]', viewer);
      var vCount = $('[data-mp-viewer-count]', viewer);
      var vHint = $('[data-mp-viewer-hint]', viewer);
      var vPrev = $('[data-mp-viewer-prev]', viewer);
      var vNext = $('[data-mp-viewer-next]', viewer);
      var slides = [];
      var cur = 0;
      var z = { s: 1, x: 0, y: 0 };
      var MAX = 4;

      if (vHint) vHint.textContent = isDesktop() ? tr('viewer_hint_desktop') : tr('viewer_hint_touch');

      function build() {
        var vis = gallery.visible();
        vTrack.innerHTML = '';
        slides = vis.map(function (s, n) {
          var b = $('[data-mp-zoom]', s);
          var src = $('img', s);
          var el = doc.createElement('div');
          el.className = 'mp-product__viewer-slide';
          el.setAttribute('role', 'group');
          el.setAttribute('aria-roledescription', tr('slide'));
          el.setAttribute('aria-label', tr('slide_of', { index: n + 1, total: vis.length }));
          var im = doc.createElement('img');
          im.className = 'mp-product__viewer-img';
          im.alt = src ? src.alt : '';
          im.draggable = false;
          im.decoding = 'async';
          im.setAttribute('data-src', b ? b.getAttribute('data-zoom-src') : (src ? src.currentSrc || src.src : ''));
          el.appendChild(im);
          vTrack.appendChild(el);
          return el;
        });
      }
      function load(i) {
        [i - 1, i, i + 1].forEach(function (n) {
          var el = slides[n];
          if (!el) return;
          var im = $('img', el);
          if (im && !im.getAttribute('src') && im.getAttribute('data-src')) im.setAttribute('src', im.getAttribute('data-src'));
        });
      }
      function img() { return slides[cur] ? $('img', slides[cur]) : null; }
      function apply(animate) {
        var im = img();
        if (!im) return;
        var el = slides[cur];
        el.classList.toggle('is-zoomed', z.s > 1);
        vTrack.classList.toggle('is-zoomed', z.s > 1);
        viewer.classList.toggle('is-zoomed', z.s > 1);
        if (!animate) el.classList.add('is-panning');
        im.style.transform = z.s > 1 ? 'translate(' + z.x.toFixed(1) + 'px,' + z.y.toFixed(1) + 'px) scale(' + z.s.toFixed(3) + ')' : '';
        if (!animate) setTimeout(function () { el.classList.remove('is-panning'); }, 0);
      }
      // deplacement borne aux bords de la photo affichee (object-fit: contain), pas a ceux du cadre
      function clamp() {
        var el = slides[cur];
        var im = img();
        if (!el) return;
        var w = el.clientWidth;
        var h = el.clientHeight;
        var cw = w;
        var ch = h;
        if (im && im.naturalWidth && im.naturalHeight) {
          var r = im.naturalWidth / im.naturalHeight;
          cw = Math.min(w, h * r);
          ch = Math.min(h, w / r);
        }
        var mx = Math.max(0, (cw * z.s - w) / 2);
        var my = Math.max(0, (ch * z.s - h) / 2);
        z.x = Math.max(-mx, Math.min(mx, z.x));
        z.y = Math.max(-my, Math.min(my, z.y));
      }
      function reset(animate) {
        z = { s: 1, x: 0, y: 0 };
        apply(animate !== false);
      }
      // garde le point (px, py) de l'ecran sous le doigt ou la souris en changeant d'echelle
      function zoomAt(px, py, s2, animate) {
        var el = slides[cur];
        if (!el) return;
        s2 = Math.max(1, Math.min(MAX, s2));
        var r = el.getBoundingClientRect();
        var cx = r.left + r.width / 2;
        var cy = r.top + r.height / 2;
        z.x = px - cx - (px - cx - z.x) * s2 / z.s;
        z.y = py - cy - (py - cy - z.y) * s2 / z.s;
        z.s = s2;
        if (z.s <= 1.01) { reset(animate); return; }
        clamp();
        apply(animate);
      }
      function go(i, smooth) {
        if (!slides.length) return;
        i = Math.max(0, Math.min(i, slides.length - 1));
        if (i !== cur) reset(false);
        cur = i;
        load(i);
        vTrack.scrollTo({ left: i * vTrack.clientWidth, behavior: smooth && !reduceMotion() ? 'smooth' : 'auto' });
        status();
      }
      function status() {
        if (vCount) vCount.textContent = (cur + 1) + ' / ' + slides.length;
        if (vPrev) vPrev.disabled = cur <= 0;
        if (vNext) vNext.disabled = cur >= slides.length - 1;
      }
      function open(i, opener, pt) {
        build();
        cur = Math.max(0, i);
        z = { s: 1, x: 0, y: 0 };
        var M = MPx();
        if (M.layer) M.layer.open(viewer, opener, { onClose: onClose });
        load(cur);
        status();
        // le calque doit etre mis en page avant le defilement initial
        setTimeout(function () {
          vTrack.scrollLeft = cur * vTrack.clientWidth;
          if (pt) {
            var im = img();
            var doZoom = function () { zoomAt(pt.x, pt.y, 2.5, true); };
            if (im && !im.complete) im.addEventListener('load', doZoom, { once: true });
            else doZoom();
          }
        }, 40);
      }
      function onClose() {
        reset(false);
        gallery.goTo(cur);
      }

      if (vPrev) vPrev.addEventListener('click', function () { go(cur - 1, true); });
      if (vNext) vNext.addEventListener('click', function () { go(cur + 1, true); });
      var st = false;
      vTrack.addEventListener('scroll', function () {
        if (st || z.s > 1) return;
        st = true;
        setTimeout(function () {
          st = false;
          var i = Math.round(vTrack.scrollLeft / Math.max(1, vTrack.clientWidth));
          if (i !== cur) { cur = i; load(i); status(); }
        }, 80);
      }, { passive: true });
      viewer.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'Right') { e.preventDefault(); go(cur + 1, true); }
        else if (e.key === 'ArrowLeft' || e.key === 'Left') { e.preventDefault(); go(cur - 1, true); }
        else if (e.key === '+' || e.key === '=') {
          e.preventDefault();
          var r1 = slides[cur] && slides[cur].getBoundingClientRect();
          if (r1) zoomAt(r1.left + r1.width / 2, r1.top + r1.height / 2, z.s * 1.5, true);
        } else if (e.key === '-' || e.key === '_') {
          e.preventDefault();
          var r2 = slides[cur] && slides[cur].getBoundingClientRect();
          if (r2) zoomAt(r2.left + r2.width / 2, r2.top + r2.height / 2, z.s / 1.5, true);
        }
      });
      // double clic (souris)
      vTrack.addEventListener('dblclick', function (e) {
        if (!e.target.closest('.mp-product__viewer-slide')) return;
        e.preventDefault();
        if (z.s > 1) reset(true);
        else zoomAt(e.clientX, e.clientY, 2.5, true);
      });
      // molette : zoom vertical ; le defilement horizontal (pave tactile) reste une navigation
      vTrack.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaX) > Math.abs(e.deltaY) && z.s <= 1) return;
        e.preventDefault();
        var f = Math.exp(-e.deltaY * (e.deltaMode === 1 ? 0.05 : 0.0025));
        zoomAt(e.clientX, e.clientY, z.s * f, false);
      }, { passive: false });

      // deplacement de l'image zoomee (souris et doigt)
      var drag = null;
      vTrack.addEventListener('pointerdown', function (e) {
        if (z.s <= 1 || e.button > 0 || pinch) return;
        drag = { id: e.pointerId, x: e.clientX, y: e.clientY, ox: z.x, oy: z.y };
        try { vTrack.setPointerCapture(e.pointerId); } catch (err) { /* sans gravite */ }
      });
      vTrack.addEventListener('pointermove', function (e) {
        if (!drag || e.pointerId !== drag.id) return;
        z.x = drag.ox + (e.clientX - drag.x);
        z.y = drag.oy + (e.clientY - drag.y);
        clamp();
        apply(false);
      });
      function endDrag(e) { if (drag && (!e || e.pointerId === drag.id)) drag = null; }
      vTrack.addEventListener('pointerup', endDrag);
      vTrack.addEventListener('pointercancel', endDrag);

      // double tap et pincement (tactile)
      var lastTap = 0;
      var lastPt = null;
      var pinch = null;
      function dist(t) { var dx = t[0].clientX - t[1].clientX; var dy = t[0].clientY - t[1].clientY; return Math.sqrt(dx * dx + dy * dy); }
      vTrack.addEventListener('touchstart', function (e) {
        if (e.touches.length === 2) {
          drag = null;
          pinch = { d: dist(e.touches), s: z.s };
        } else if (e.touches.length === 1) {
          var t = e.touches[0];
          var now = Date.now();
          if (now - lastTap < 300 && lastPt && Math.abs(t.clientX - lastPt.x) < 30 && Math.abs(t.clientY - lastPt.y) < 30) {
            e.preventDefault();
            if (z.s > 1) reset(true);
            else zoomAt(t.clientX, t.clientY, 2.5, true);
            lastTap = 0;
            return;
          }
          lastTap = now;
          lastPt = { x: t.clientX, y: t.clientY };
        }
      }, { passive: false });
      vTrack.addEventListener('touchmove', function (e) {
        if (!pinch || e.touches.length !== 2) return;
        e.preventDefault();
        var mx = (e.touches[0].clientX + e.touches[1].clientX) / 2;
        var my = (e.touches[0].clientY + e.touches[1].clientY) / 2;
        zoomAt(mx, my, pinch.s * dist(e.touches) / pinch.d, false);
      }, { passive: false });
      vTrack.addEventListener('touchend', function (e) {
        if (pinch && e.touches.length < 2) {
          pinch = null;
          if (z.s <= 1.05) reset(true);
        }
      });
      window.addEventListener('resize', function () { if (slides.length && MPx().layer && MPx().layer.isOpen(viewer)) { reset(false); vTrack.scrollLeft = cur * vTrack.clientWidth; } });

      return { open: open };
    })();

    /* ---------- Barre d'achat collante ---------- */
    (function () {
      if (!bar || !addBtn || !('IntersectionObserver' in window)) return;
      var mainVisible = true;
      var mainAbove = false;
      var footVisible = false;
      function render() {
        var show;
        if (isDesktop()) show = !mainVisible && mainAbove;
        else show = !mainVisible && !footVisible;
        bar.classList.toggle('is-on', show);
        bar.inert = !show;
        if (!show && bar.contains(doc.activeElement)) addBtn.focus({ preventScroll: true });
      }
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          mainVisible = en.isIntersecting;
          mainAbove = en.boundingClientRect.top < 0;
        });
        render();
      }, { threshold: 0 }).observe(addBtn);
      var foot = doc.querySelector('.mp-footer') || doc.querySelector('footer');
      if (foot) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { footVisible = en.isIntersecting; });
          render();
        }, { threshold: 0 }).observe(foot);
      }
      var M = MPx();
      if (M.mq && M.mq.desktop && M.mq.desktop.addEventListener) M.mq.desktop.addEventListener('change', render);
    })();

    /* ---------- Colonne d'achat collante, meme plus haute que l'ecran ---------- */
    (function () {
      if (!info) return;
      function fit() {
        if (!isDesktop()) { info.style.removeProperty('--mp-info-top'); return; }
        var h = info.offsetHeight;
        var vh = window.innerHeight;
        if (h + headerOffset() + 48 > vh) info.style.setProperty('--mp-info-top', Math.round(vh - h - 24) + 'px');
        else info.style.removeProperty('--mp-info-top');
      }
      if ('ResizeObserver' in window) new ResizeObserver(fit).observe(info);
      window.addEventListener('resize', MPx().debounce ? MPx().debounce(fit, 120) : fit);
      window.addEventListener('load', fit, { once: true });
      fit();
    })();

    update(false, -1);
    // retour arriere sur une page en cache : les radios peuvent avoir garde un autre etat
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      for (var x = 0; x < nOpt; x++) {
        inputsByOpt[x].forEach(function (inp) { if (inp.checked) sel[x] = inp.value; });
      }
      update(false, ci);
    });
  }

  /* =====================================================================
     2. Recommandations Shopify (You may also like, Complete the look)
     ===================================================================== */
  function initRecos(box, intent, trackSel, min) {
    if (!box || box.__mpRecos) return;
    box.__mpRecos = true;
    var url = box.getAttribute('data-url');
    var pid = box.getAttribute('data-product-id');
    var sec = box.getAttribute('data-section-id');
    var gender = box.getAttribute('data-gender') || 'f';
    var limit = parseInt(box.getAttribute('data-limit'), 10) || 12;
    if (!url || !pid || !sec || !window.fetch) return;

    function run() {
      var u = url + '?section_id=' + encodeURIComponent(sec) + '&product_id=' + encodeURIComponent(pid) + '&limit=' + Math.min(10, limit + 2) + '&intent=' + intent;
      fetch(u, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html) return;
          var d = new DOMParser().parseFromString(html, 'text/html');
          var list = d.querySelector('[data-mp-recos-result]');
          if (!list) return;
          // jamais homme et femme melanges : seules les pieces du genre de la fiche (ou mixtes)
          var items = $$('li[data-g]', list).filter(function (li) {
            var g = li.getAttribute('data-g');
            return (g === 'm' || g === gender) && li.getAttribute('data-id') !== pid;
          });
          if (items.length < min) return;
          var track = $(trackSel, box);
          if (!track) return;
          var seen = {};
          var frag = doc.createDocumentFragment();
          var n = 0;
          items.forEach(function (li) {
            if (n >= limit) return;
            seen[li.getAttribute('data-id')] = true;
            frag.appendChild(doc.importNode(li, true));
            n++;
          });
          // complete avec le repli serveur pour garder une rangee pleine
          $$(':scope > li', track).forEach(function (li) {
            if (n >= limit || seen[li.getAttribute('data-id')]) return;
            frag.appendChild(li);
            n++;
          });
          track.innerHTML = '';
          track.appendChild(frag);
          var M = MPx();
          if (box.__mpRow) box.__mpRow.update();
          else if (M.rows) M.rows(box.parentNode);
        })
        .catch(function () { /* le repli serveur reste affiche */ });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (en) { return en.isIntersecting; })) {
          io.disconnect();
          run();
        }
      }, { rootMargin: '600px 0px' });
      io.observe(box);
    } else {
      run();
    }
  }

  /* =====================================================================
     3. Selecteurs de taille des cartes "Complete the look"
     ===================================================================== */
  doc.addEventListener('change', function (e) {
    var s = e.target && e.target.closest ? e.target.closest('[data-mp-complete-select]') : null;
    if (!s) return;
    var card = s.closest('[data-mp-quick]');
    if (!card) return;
    var b = $('[data-mp-quick-add]', card);
    if (b) b.setAttribute('data-mp-quick-add', s.value);
    var m = $('[data-mp-quick-msg]', card);
    if (m) m.textContent = '';
  });

  /* =====================================================================
     4. Demarrage (et rechargement de section dans l'editeur)
     ===================================================================== */
  function start(scope) {
    var root = scope || doc;
    $$('[data-mp-product]', root).forEach(initProduct);
    $$('[data-mp-recos]', root).forEach(function (b) { initRecos(b, 'related', '[data-mp-recos-track]', 4); });
    $$('[data-mp-complete]', root).forEach(function (b) { initRecos(b, 'complementary', '[data-mp-complete-track]', 2); });
    if (root !== doc && root.matches) {
      if (root.matches('[data-mp-product]')) initProduct(root);
    }
  }

  function boot() {
    start(doc);
    doc.addEventListener('shopify:section:load', function (e) { start(e.target); });
    doc.addEventListener('shopify:section:unload', function (e) {
      var id = e.detail && e.detail.sectionId;
      if (id) dropPortals(id, []);
    });
  }

  if (window.MP && typeof window.MP.ready === 'function') window.MP.ready(boot);
  else if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
